import { useApiQuery } from '../useApiQuery'
import * as api from '../api'
import { z } from 'zod'

export default function useParticipantsOtherGroupAssignmentsThanManagerGroups(
  courseUuid: string,
  participantsUuids: string[],
  managerUuid: string | undefined,
  run: boolean
) {
  const { data, ...result } = useApiQuery({
    enabled: participantsUuids.length > 0 && !!managerUuid && run,
    queryKey: ['useParticipantsOtherGroupAssignmentsThanManagerGroups'],
    placeholderData: (previousData) => previousData || [],
    queryFn: async () => {
      const response = await api.post(`scheduled-course/${encodeURIComponent(courseUuid)}/participants-assignments`, {
        participantsUuids,
        managerUuid,
      })

      return z
        .array(
          z.object({
            participantUuid: z.string().uuid(),
            hasDirectAssignmentFromManager: z.boolean(),
            finishedAt: z.string().nullable(),
            // The course can be assigned to the user/participant by more than one group. This
            // flag is TRUE if the course is assigned to the user/participant by a group
            // that provided managerUuid is not a manager of.
            hasOtherGroupsAssignmentsThanFromProvidedManager: z.boolean(),
          })
        )
        .parse(response)
    },
  })

  return { participantsWithOtherAssignments: data || [], ...result }
}
